/* ============================================================
   TENUTA GRIECI · tg-menu.js   —   16/10/2026
   Apertura e chiusura del menu (overlay #menuOverlay).

   Prima il pulsante "Menu" era collegato da theme.js, che tg-funnel.js
   inietta solo quando esce il loader: su telefono il primo tocco spesso
   non faceva nulla. All'apertura partivano una tendina clip-path di 0,85 s,
   le voci sfumate con blur e i marquee GSAP, che al tocco coprivano la
   voce appena toccata.

   Ora:
   · questo file si carica dal layout (defer) e risponde subito;
   · su telefono e tablet (≤950 px o schermo touch) il menu si apre e si
     chiude all'istante, senza animazioni (stili in tg-menu.css);
   · su desktop resta la tendina, fatta in CSS;
   · i click sono intercettati in fase di cattura su window, così il
     vecchio gestore di theme.js non parte più (niente doppio toggle)
     e theme.js non va toccato;
   · pagina sotto bloccata mentre il menu è aperto, voce della pagina
     corrente in oro, Esc chiude, il menu non resta aperto tornando
     indietro con il browser.
   Focus e inert li gestisce già tg-a11y.js osservando aria-expanded.
   ============================================================ */
(function () {
  'use strict';
  var toggle = document.getElementById('menuToggle');
  var overlay = document.getElementById('menuOverlay');
  if (!toggle || !overlay) return;

  var root = document.documentElement;
  var open = false;

  function samePage(a) {
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return false; }
    if (u.origin !== location.origin || u.hash) return false;
    return u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
  }

  function markCurrent() {
    var links = overlay.querySelectorAll('.menu__item-link');
    for (var i = 0; i < links.length; i++) {
      if (samePage(links[i])) links[i].setAttribute('aria-current', 'page');
      else links[i].removeAttribute('aria-current');
    }
  }

  function set(state) {
    if (state === open) return;
    open = state;
    document.body.classList.toggle('menu-open', open);
    root.classList.toggle('tg-menu-lock', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (window.__lenis) { try { open ? window.__lenis.stop() : window.__lenis.start(); } catch (e) {} }
    if (open) {
      markCurrent();
      var wrap = overlay.querySelector('.menu-wrap');
      if (wrap) wrap.scrollTop = 0;
    }
  }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#menuToggle')) {
      /* Niente preventDefault (17/10/2026): il pulsante è type="button" e non
         ha azioni da annullare, e su iPhone il clic arriva all'interruttore
         di tg-haptics.js, che annullato non vibrerebbe. */
      e.stopPropagation();
      set(!open);
      return;
    }
    if (open && t.closest('#menuOverlay a[href]')) {
      /* la navigazione parte comunque: si chiude e basta */
      e.stopPropagation();
      set(false);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) {
      set(false);
      try { toggle.focus({ preventScroll: true }); } catch (err) { toggle.focus(); }
    }
  });

  /* Safari/Chrome ripristinano la pagina dalla cache tornando indietro:
     senza questo il menu si ritroverebbe aperto. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) set(false); });
})();
